import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Bed = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4Zm-2 3v-3a2 2 0 0 0-2-2h-4v5h6ZM8 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
    />
  </svg>
));
